import {
  IngredientMetricUnit,
  RecipeMetricUnit,
} from '../../generated/graphql';

export function getSubRecipePrepTime({
  unit,
  quantity,
  recipeServes,
  totalGrams,
  totalTime,
}: {
  unit: string;
  quantity: number;
  recipeServes: number;
  totalGrams: number;
  totalTime: number;
}) {
  switch (unit.toUpperCase()) {
    case RecipeMetricUnit.Serve:
      return (quantity / recipeServes) * totalTime;

    case IngredientMetricUnit.Gram:
      return (quantity / totalGrams) * totalTime;

    default:
      return 0;
  }
}
